import { AspectRatio, Box, Button, Image } from '@mantine/core'
import { IconRefresh } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import ImagePlaceholder from '@/assets/image-placeholder.png'

const ASPECT_RATIO = 16 / 9

type CameraImageProps = {
  imageUrl?: string
  isRefreshing?: boolean
  onRefresh: () => void
}

export const CameraImage = ({
  imageUrl,
  isRefreshing,
  onRefresh
}: CameraImageProps) => {
  return (
    <Box pos="relative">
      <AspectRatio ratio={ASPECT_RATIO}>
        <Image
          fit="cover"
          src={imageUrl || ImagePlaceholder}
          fallbackSrc={ImagePlaceholder}
          radius="sm"
          styles={(theme) => ({
            root: {
              outline: `1px solid ${theme.colors.dark[3]}`
            }
          })}
        />
      </AspectRatio>

      <Button
        size="compact-xs"
        color="brand-secondary"
        pos="absolute"
        top={8}
        right={8}
        rightSection={<IconRefresh size={16} />}
        loading={isRefreshing}
        onClick={onRefresh}
      >
        <FormattedMessage id="cameras.image.refresh" />
      </Button>
    </Box>
  )
}
